import { Card } from '@heroui/react'
import type { SettingsCardProps } from '../../../../types'

export interface ExtendedSettingsCardProps extends SettingsCardProps {
  title?: string // Optional title for the card
  description?: string // Optional description for better accessibility
}

export const SettingsCard = ({
  children,
  title,
  description
}: ExtendedSettingsCardProps) => {
  return (
    <section>
      <Card
        className="border border-[var(--ds-border)] bg-[var(--ds-surface)] rounded-[3px] shadow-none p-6"
        data-testid="settings-card"
        aria-label={title || 'Settings section'}
        aria-description={description}
      >
        {children}
      </Card>
    </section>
  )
}
